export const getAccountConfirmationBgColor = (account: {
  confirmed: boolean;
}) => (account.confirmed ? "#8CF6CA" : "#F7B28C");

export const getAccountSuspendBgColor = (account: {
  suspended: { value: boolean };
}) => (account.suspended.value ? "#8CF6CA" : "#F7B28C");
